<mat-form-field [formGroup]="group">
  <input matInput
    id="{{ idx }}"
    formControlName="{{ controlName }}"
    maxlength="{{ maxlength }}"
    placeholder="{{ placeholder }}"
    [attr.aria-pressed]=""
    type="{{ type }}"
    [attr.autocomplete]="autocomplete"
    [textMask]="{ mask: mask, guide: false, keepCharPositions: true, modelClean: true }">
  <mat-icon *ngIf="suffix" matSuffix>{{ suffix }}</mat-icon>
  <mat-hint>{{ content.hint }} <span class="mat_hit_hidden"  *ngIf="required">required</span></mat-hint>
  <mat-error *ngIf="group.controls[controlName].invalid" [attr.aria-label]="content.hint + validationMessage.get(group.controls[controlName], placeholder) ">{{ content.hint }} {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
</mat-form-field>